import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { trackV2 } from 'utils/analytics';
import FindFacebookFriends from '../../../friends/FindFacebookFriends';
import { INVITE_FRIENDS } from '../../../friends/utils/friendsConstants';

const FacebookReactPanel = ({
  source,
  currentAthlete,
  locale,
  fbAppId,
  fbVersion,
  defaultTab
}) => {
  const track = useCallback(
    (fields) => {
      trackV2({
        page: 'find_and_invite',
        category: 'connections',
        ...fields,
        properties: {
          source,
          default_tab: defaultTab,
          ...fields.properties
        }
      });
    },
    [defaultTab, source]
  );

  return (
    <FindFacebookFriends
      track={track}
      currentAthlete={currentAthlete}
      source={INVITE_FRIENDS}
      fbApiProps={{
        appId: fbAppId,
        version: fbVersion,
        locale
      }}
    />
  );
};

FacebookReactPanel.propTypes = {
  source: PropTypes.oneOf([
    'athlete_search',
    'dashboard_sidebar',
    'follows_blocked',
    'follows_followers',
    'follows_following',
    'follows_suggested',
    'header_menu',
    'onboarding' // facebook button on onboarding dashboard feed
  ]).isRequired,
  fbAppId: PropTypes.number.isRequired,
  fbVersion: PropTypes.string.isRequired,
  currentAthlete: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired,
  defaultTab: PropTypes.oneOf(['email', 'facebook']).isRequired
};

export default FacebookReactPanel;
